import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "requisites-container px-3 py-4" }
const _hoisted_2 = { class: "container d-flex requisites-sub-container p-1" }
const _hoisted_3 = { class: "requisites-sub-container__data font-medium col-8" }
const _hoisted_4 = { class: "mob-font tablet-font" }
const _hoisted_5 = { class: "fw-bold pb-2 ps-1" }
const _hoisted_6 = { class: "requisites-container__items" }
const _hoisted_7 = { class: "p-1" }
const _hoisted_8 = { class: "p-1" }
const _hoisted_9 = {
  class: "a-display-style",
  href: "https://www.google.com/maps/place/Rugi%C5%B3+g.+4A,+Vilnius+08418/@54.7408595,25.2742982,19.5z/data=!4m5!3m4!1s0x46dd91225bf6bfe5:0xc4a10877939081a!8m2!3d54.7408916!4d25.2743853"
}
const _hoisted_10 = { class: "p-1" }
const _hoisted_11 = { class: "p-1" }
const _hoisted_12 = { class: "p-1" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "p-1" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "p-1" }
const _hoisted_17 = { class: "p-1" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "p-1" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "font-medium col-4 d-flex justify-content-end align-items-center" }
const _hoisted_22 = { class: "mob-font tablet-font p-2" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "container-fluid bg-white p-3" }
const _hoisted_25 = { class: "container private-policy d-flex justify-content-between align-items-center font-medium p-2" }
const _hoisted_26 = { class: "d-flex mob-font tablet-font col-6" }
const _hoisted_27 = { class: "d-flex mob-tablet-flex-direction justify-content-end mob-font tablet-font col-6" }
const _hoisted_28 = { class: "p-2" }
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = { class: "p-2" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", {
      class: _normalizeClass(["container-fluid p-0", { 'dont_print': _ctx.store.state.customer.printing }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('requisites').toUpperCase()), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.store.state.company.company_name), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.$t('address')) + ": ", 1),
                  _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.store.state.company.company_address), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('company_code')) + ": " + _toDisplayString(_ctx.store.state.company.company_code), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('vat_code')) + ": " + _toDisplayString(_ctx.store.state.company.vat_code), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('tel')) + ": ", 1),
                  _createElementVNode("a", {
                    class: "a-display-style",
                    href: 'tel:'+_ctx.$filters.phoneBeautify(_ctx.store.state.company.phone_number) 
                  }, _toDisplayString(_ctx.$filters.phoneBeautify(_ctx.store.state.company.phone_number)), 9, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.$t('email')) + ": ", 1),
                  _createElementVNode("a", {
                    class: "a-display-style",
                    href: 'mailto:'+_ctx.store.state.company.info_mail
                  }, _toDisplayString(_ctx.store.state.company.info_mail), 9, _hoisted_15)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('bank_account')) + ": " + _toDisplayString(_ctx.store.state.company.bank_account), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_ctx.$t('finance')) + ": ", 1),
                  _createElementVNode("a", {
                    class: "a-display-style",
                    href: 'tel:'+_ctx.$filters.phoneBeautify(_ctx.store.state.company.finance_phone) 
                  }, _toDisplayString(_ctx.$filters.phoneBeautify(_ctx.store.state.company.finance_phone)), 9, _hoisted_18)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createTextVNode(_toDisplayString(_ctx.$t('director')) + ": ", 1),
                  _createElementVNode("a", {
                    class: "a-display-style",
                    href: 'tel:'+_ctx.$filters.phoneBeautify(_ctx.store.state.company.director_phone) 
                  }, _toDisplayString(_ctx.$filters.phoneBeautify(_ctx.store.state.company.director_phone)), 9, _hoisted_20)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("ul", _hoisted_22, [
              _createElementVNode("li", _hoisted_23, _toDisplayString(_ctx.$t('working_hours').toUpperCase()), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.store.state.company.working_hours_footer), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('all_rights')) + ". © " + _toDisplayString(_ctx.dateNow) + " " + _toDisplayString(_ctx.$t('minibus_rental')) + " – " + _toDisplayString(_ctx.store.state.company.company_name) + ". ", 1),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _renderSlot(_ctx.$slots, "purchase-declaration-link", {}, undefined, true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _renderSlot(_ctx.$slots, "cookies-link", {}, undefined, true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _renderSlot(_ctx.$slots, "privacy-link", {}, undefined, true)
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_ModalComponent, {
      "id-data": "purchaseDeclarationModal",
      "modal-title": _ctx.$t('purchase_declaration')
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", {
          style: {"line-height":"1.5rem"},
          innerHTML: _ctx.store.state.company.purchase_declaration
        }, null, 8, _hoisted_31)
      ]),
      _: 1
    }, 8, ["modal-title"]),
    _createVNode(_component_ModalComponent, {
      "id-data": "cookiesModal",
      "modal-title": _ctx.$t('cookies_consent')
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", {
          style: {"line-height":"1.5rem"},
          innerHTML: _ctx.store.state.company.cookies_consent
        }, null, 8, _hoisted_32)
      ]),
      _: 1
    }, 8, ["modal-title"]),
    _createVNode(_component_ModalComponent, {
      "id-data": "privacyModal",
      "modal-title": _ctx.$t('privacy_policy')
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", {
          style: {"line-height":"1.5rem"},
          innerHTML: _ctx.store.state.company.privacy_policy
        }, null, 8, _hoisted_33)
      ]),
      _: 1
    }, 8, ["modal-title"])
  ], 64))
}